import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Note from './note-icon.svg';

// Use NoteRegularIcon instead
// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Note {...validProps} />;
}
SvgComponent.iconName = 'note';

/**
 * @deprecated This is a legacy icon
 */
export const NoteIcon = svgIconWrapper(SvgComponent);
